module.exports = __webpack_public_path__ + "assets/img/close.4b7ddc39.svg";